/**
 * Prod UserMenu routes accepted/auto_accepted to outgoing (/notification/to),
 * all other statuses to received (/notification/from).
 */
export function getNotificationBellDestination(requestStatus) {
  if (requestStatus === 'accepted' || requestStatus === 'auto_accepted') {
    return '/notification?tab=outgoing';
  }
  return '/notification?tab=received';
}
